
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertheaderGroupLargeIec as ObiAlertheaderGroupLargeIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alertheader-group-large-iec.js';
 
 
 

 
 export const ObiAlertheaderGroupLargeIec = createComponent({
   react: React,
   tagName: 'obi-alertheader-group-large-iec',
   elementClass: ObiAlertheaderGroupLargeIecElement,
   events: {
     
   }
  });
 
 